import { defineStore } from 'pinia';
import { ref } from 'vue'
import { useCcPaymentStore } from './payment_gateways/ccpayment';
import { usePaymentGatewaysStore } from '../payment_gateways';
import _ from 'lodash';

export const useWithdrawalsStore = defineStore('withdrawals', {
	state: () => ({
		payment_gateways: ref({}),
	}),
	getters: {
		getPaymentGateways(state) {
			const allowed_payment_gateways = ['plisio', 'coinpayments', 'hubtel', '0xprocessing', 'iran-voucher', 'central-pay', 'perfect-money', 'perfect-money-voucher', 'ccpayment', 'usdt', 'trx', 'utopia_voucher', 'slot4pay', 'manual_deposit_proof', 'gizapay', 'neopay', 'aleapay', 'riverpe', 'modem_pay'];

			return _.filter(state.payment_gateways, (gateway) => {
				return _.includes(allowed_payment_gateways, gateway.slug);
			});
		},
		getAvailableBonuses(state) {
			return state.available_bonuses;
		},
		isCcpaymentEnabled(state) {
			return state.payment_gateways.some(gateway => gateway.slug === 'ccpayment');
		},
	},
	actions: {
		fetchPaymentGateways() {
			return global.axios.get(process.env.VUE_APP_API_URL + '/account/bank/withdraw/payment_gateways').then((response) => {
				this.payment_gateways = response.data.data;

				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		getPaymentGateway(slug) {
			return _.find(this.payment_gateways, { 'slug': slug });
		},
		// Plisio
		createWithdrawPlisio(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/plisio', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// CoinPayments
		createWithdrawCoinPayments(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/coinpayments', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// 0xprocessing
		createWithdraw0xProcessing(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/0xprocessing', payload).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Hubtel
		createWithdrawHubtel(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/hubtel', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Iran Voucher
		createWithdrawIranVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/iran-voucher', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Central Pay
		createWithdrawCentralPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/central-pay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Perfect Money
		createWithdrawPerfectMoney(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/V2/perfect-money', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Perfect Money Voucher
		createWithdrawPerfectMoneyVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/perfect-money-voucher', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// CCPayment
		createWithdrawCcPayment(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/ccpayment', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Utopia Voucher
		createWithdrawUtopiaVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/utopia-voucher', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Slot4Pay
		createWithdrawSlot4Pay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/slot4pay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// GizaPay
		createWithdrawGizaPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/gizapay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Neopay
		createWithdrawNeopay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/neopay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Aleapay
		createWithdrawAleapay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/aleapay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Webpayz
		createWithdrawWebpayz(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/webpayz', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Transaction Proof
		createWithdrawTransactionProof(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/manual-deposit-proof', payload).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Riverpe
		createWithdrawRiverpe(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/riverpe', payload).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// ModemPay
		createWithdrawModemPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/withdraw/modempay', payload).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		setPaymentGateways(data) {
			const paymentGatewaysStore = usePaymentGatewaysStore();
			this.payment_gateways = data;

			if (this.isCcpaymentEnabled) {
				const ccpayment = data.find(gateway => gateway.slug === 'ccpayment');
				const original_logo_array = ccpayment.logo;
				ccpayment.logo = original_logo_array.find(logo => logo.slug === 'ccpayment') || null;
				const usdt_logo = original_logo_array.find(logo => logo.slug === 'ccpayment_usdt') || null;
				const trx_logo = original_logo_array.find(logo => logo.slug === 'ccpayment_trx') || null;

				const shared_properties = {
					supported_currencies: ccpayment.supported_currencies,
					currencies: ccpayment.currencies,
					withdraw_sort: ccpayment.withdraw_sort,
				};

				const ccpaymentStore = useCcPaymentStore();
				ccpaymentStore.fetchCurrencies().then((response) => {
					ccpaymentStore.withdraw_currencies = response.withdraw_coins;

					this.payment_gateways = [...data];

					if (ccpaymentStore.getUsdtCoins('withdraw') && ccpaymentStore.getUsdtCoins('withdraw').length > 0) {
						this.payment_gateways.push({
							id: 1000,
							slug: 'usdt',
							label: 'USDT',
							logo: usdt_logo,
							...shared_properties
						});
					}

					if (ccpaymentStore.getTrxCoins('withdraw') && ccpaymentStore.getTrxCoins('withdraw').length > 0) {
						this.payment_gateways.push({
							id: 1001,
							slug: 'trx',
							label: 'TRX',
							logo: trx_logo,
							...shared_properties
						});
					}

				}).catch((error) => {
					console.log(error);
				}).finally(() => {
					paymentGatewaysStore.global_withdrawal_payment_loading = false;
				});
			} else {
				paymentGatewaysStore.global_withdrawal_payment_loading = false;
			}
		}
	},
})